(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["air-quality-landing-page-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.getElementById('air-form');
    const report = document.getElementById('report');
    if (!form || !report) return;
    const WORKER = 'https://betterbrand-air-quality.royal-dew-fe05.workers.dev';
    const SERVE = 'https://yswqqjakuifsgslwskgq.supabase.co/functions/v1/serve-form/aq-report/submit';
    const LOGBASE = 'https://yswqqjakuifsgslwskgq.supabase.co/functions/v1/serve-form';
    const BASE = /(^|\.)trybetterbrand\.com$/.test(location.hostname) ? 'aqi-v3' : 'air-report';
    // A/B variant: OPT-IN ONLY. ?variant=X in the URL wins and sticks (own key, so stale bb_ab
    // values from the old auto-split can never resurrect it). No URL param = no suffix, no
    // random bucketing: this page reports as ONE tag so the sample is not cut in half.
    const VARIANT = (function(){try{
      var q=(new URLSearchParams(location.search).get('variant')||'').trim().toUpperCase().slice(0,12);
      if(q){localStorage.setItem('bb_ab_v3',q);return q;}
      return localStorage.getItem('bb_ab_v3')||'';
    }catch(_){return '';}})();
    const VERSION = VARIANT ? BASE + '-' + VARIANT : BASE;   // 'aqi-v3' normally; 'aqi-v3-A' only with ?variant=A
    const PIXEL_ID = '451332722114843';                // BetterBrand Meta pixel (ours)
    function dayKey(){try{return new Date().toLocaleDateString('en-CA',{timeZone:'America/Chicago'});}catch(_){return new Date().toISOString().slice(0,10);}}
    const VAR1=50211146957099, SUBPLAN=118714663211;
    const URL_SUB='https://www.trybetterbrand.com/cart/'+VAR1+':1?selling_plan='+SUBPLAN;
    const URL_ONCE='https://www.trybetterbrand.com/cart/'+VAR1+':1?discount=AIR20';
    const DISC='https://www.trybetterbrand.com/discount/AIR20?redirect=/products/betterlungs-r-mullein-gummies';
    const BUYBOX=
      '<div class="bb">'+
        '<div class="bb-head"><img class="bb-thumb" src="https://air-report.pages.dev/assets/img/gummies-1bag.jpg" alt="BetterLungs Mullein Gummies pouch" loading="lazy"><div class="bb-htx"><div class="bb-title">BetterLungs® Mullein Gummies</div><div class="bb-supply" id="bb-supply">30-day supply</div></div></div>'+
        '<div class="bb-packs">'+
          '<button type="button" class="pk selected" data-pack="1">1 Bag</button>'+
          '<button type="button" class="pk" data-pack="3">3 Bags<small>Save more</small></button>'+
          '<button type="button" class="pk" data-pack="6">6 Bags<small>Best price</small></button>'+
        '</div>'+
        '<div class="bb-plan selected" id="bb-sub" data-plan="sub"><span class="bb-radio"></span><div class="bb-plan-main"><div class="bb-plan-name">Subscribe &amp; Save <span class="bb-best">Best value</span></div><div class="bb-plan-desc" id="bb-sub-desc">20% off · ships monthly · cancel anytime</div></div><div class="bb-plan-price" id="bb-sub-price"><span class="bb-now">$27.96</span><span class="bb-was">$34.95</span><span class="bb-per">/mo</span></div></div>'+
        '<div class="bb-plan" id="bb-once" data-plan="once"><span class="bb-radio"></span><div class="bb-plan-main"><div class="bb-plan-name">One-time purchase</div><div class="bb-plan-desc">20% off with code AIR20</div></div><div class="bb-plan-price" id="bb-once-price"><span class="bb-now">$27.96</span><span class="bb-was">$34.95</span></div></div>'+
        '<a class="bb-cta" id="bb-cta" href="#" target="_blank" rel="noopener">Subscribe · $27.96/mo &rarr;</a>'+
        '<div class="bb-trust"><span>✓ 365-day guarantee</span><span>✓ Free shipping</span><span>✓ Cancel anytime</span></div>'+
      '</div>';
    const STICKY='<div class="bb-sticky" id="bb-sticky"><div class="bb-sticky-in"><div class="lbl">BetterLungs® Gummies <span id="bb-sticky-sub">Subscribe &amp; Save · $27.96</span></div><a id="bb-sticky-cta" href="'+URL_SUB+'" target="_blank" rel="noopener">Add to cart</a></div></div>';
    const SID = (function(){try{let s=sessionStorage.getItem('aq_sid');if(!s){s=Date.now().toString(36)+Math.random().toString(36).slice(2,8);sessionStorage.setItem('aq_sid',s);}return s;}catch(_){return '';}})();
    // BB Pixel: persistent first-party visitor id (survives sessions) — our own tracking, no Northbeam/Meta.
    const VID = (function(){try{let v=localStorage.getItem('bb_vid');if(!v){v='v'+Date.now().toString(36)+Math.random().toString(36).slice(2,10);localStorage.setItem('bb_vid',v);}return v;}catch(_){return '';}})();
    function withRef(u){var sep=u.indexOf('?')>-1?'&':'?';return u+sep+'bb_vid='+encodeURIComponent(VID)+'&bb_src='+encodeURIComponent(VERSION);}
    const T0 = Date.now();
    function aqTrack(t,x){fetch(LOGBASE+'/aq-event',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(Object.assign({type:t,page_version:VERSION,variant:VARIANT,day:dayKey(),ts:new Date().toISOString(),session_id:SID,vid:VID,path:location.pathname,elapsed_ms:Date.now()-T0},x||{})),keepalive:true}).catch(()=>{});}
    // Everything only the browser knows: real traffic source + ad click ids + device.
    // Read ONCE, synchronously, then it rides the existing /aq-view POST below — no extra
    // request, no listeners, no render work. Server drops it into a jsonb column, so any
    // future slice (source, campaign, device, landing URL) needs no page edit ever again.
    const META = (function(){try{
      var p=new URLSearchParams(location.search), m={},
          k=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid','ttclid'];
      for(var i=0;i<k.length;i++){var v=p.get(k[i]); if(v) m[k[i]]=String(v).slice(0,120);}
      m.ref=(document.referrer||'').slice(0,300);   // the REAL referrer — the Referer header is
      m.url=location.href.slice(0,500);             // stripped to our own origin cross-domain
      m.sw=screen.width; m.sh=screen.height; m.vw=window.innerWidth; m.vh=window.innerHeight;
      m.lang=navigator.language||'';
      try{m.tz=Intl.DateTimeFormat().resolvedOptions().timeZone||'';}catch(_){}
      return m;
    }catch(_){return {};}})();
    (function(){var K='aq_viewed_'+VERSION;try{if(sessionStorage.getItem(K))return;sessionStorage.setItem(K,'1');}catch(_){}fetch(LOGBASE+'/aq-view',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({page_version:VERSION,variant:VARIANT,day:dayKey(),ts:new Date().toISOString(),session_id:SID,vid:VID,path:location.pathname,meta:META}),keepalive:true}).catch(()=>{});})();
    // Funnel step 1 (the one that was missing): form actually reached the viewport.
    // One-shot IntersectionObserver, disconnects on first hit. No scroll handler.
    (function(){try{if(!('IntersectionObserver' in window))return;var io=new IntersectionObserver(function(es){for(var i=0;i<es.length;i++){if(es[i].isIntersecting){io.disconnect();aqTrack('form_seen');return;}}},{threshold:0.25});io.observe(form);}catch(_){}})();
    form.addEventListener('focusin',(function(){let s=false;const t={};return function(e){var f=e.target&&e.target.name;if(!s){s=true;aqTrack('form_start',{field:f||''});}if(f&&!t[f]){t[f]=1;aqTrack('field_focus',{field:f});}};})());
    form.addEventListener('submit',()=>{aqTrack('submit_attempt');},true);
    const btn=form.querySelector('.fbtn'), errEl=form.querySelector('.ferr');
    const esc=(s)=>String(s).replace(/[&<>"]/g,(c)=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
    function showErr(m){if(errEl){errEl.textContent=m;errEl.hidden=false;}aqTrack('error_shown',{message:m});}
    function captureLead(d){const digits=(d.phone||'').replace(/\D/g,'');if(digits.length>=10){fetch(SERVE,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({firstName:d.first_name,name:d.first_name,email:d.email,phone:d.phone,page_version:VERSION,variant:VARIANT,properties:{'Zip Code':d.zip,'AB Variant':VARIANT}})}).catch(()=>{});}else{fetch(WORKER,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:d.email,first_name:d.first_name,zip_code:d.zip,page_version:VERSION,variant:VARIANT})}).catch(()=>{});}}
    function pm25FromAqi(a){var bp=[[0,50,0,9],[51,100,9.1,35.4],[101,150,35.5,55.4],[151,200,55.5,125.4],[201,300,125.5,225.4],[301,500,225.5,325.4]];for(var i=0;i<bp.length;i++){var b=bp[i];if(a<=b[1])return (a-b[0])/(b[1]-b[0])*(b[3]-b[2])+b[2];}return 325;}
    function countUp(el,target,dur){var t0=performance.now();(function tick(now){var p=Math.min(1,(now-t0)/(dur||1200));el.textContent=Math.round((1-Math.pow(1-p,3))*target);if(p<1)requestAnimationFrame(tick);else el.textContent=target;})(t0);}
    function topbar(){return '<div class="rep-top"><a class="rep-logo-link" href="https://www.trybetterbrand.com/" aria-label="BetterBrand home"><img class="rep-logo" src="https://air-report.pages.dev/assets/img/betterbrand-logo-green.png" alt="BetterBrand"></a><button class="rep-close" id="rep-close">Start over</button></div>';}
    function textColor(cat){cat=(cat||'').toLowerCase();if(cat.indexOf('good')>=0)return '#2f7d20';if(cat.indexOf('sensitive')>=0)return '#c25200';if(cat.indexOf('moderate')>=0)return '#8a6a00';if(cat.indexOf('very')>=0)return '#7b1fa2';if(cat.indexOf('hazard')>=0)return '#7e0023';if(cat.indexOf('unhealthy')>=0)return '#c62828';return '#2a2f33';}
    function closeReport(){report.classList.remove('on');document.body.style.overflow='';setTimeout(function(){report.hidden=true;report.scrollTop=0;},450);}
    var PACKS={
      '1':{v:50211146957099, sub:{plan:118714663211,price:'$27.96',per:'/mo',cad:'ships monthly'}, once:'$27.96', was:'$34.95', supply:'30-day supply'},
      '3':{v:50211146989867, sub:{plan:118714728747,price:'$69.90',per:'/3 mo',cad:'ships every 3 months'}, once:'$75.48', was:'$94.35', supply:'90-day supply · $25.16/bag'},
      '6':{v:51683833741611, sub:null, once:'$142.56', was:'$178.20', supply:'180-day supply · $23.76/bag'}
    };
    function wireBuyBox(){
      var packEls=report.querySelectorAll('.pk'); if(!packEls.length){ var rc0=document.getElementById('rep-close'); if(rc0) rc0.addEventListener('click',closeReport); return; }
      var subCard=document.getElementById('bb-sub'), onceCard=document.getElementById('bb-once'),
          subPrice=document.getElementById('bb-sub-price'), subDesc=document.getElementById('bb-sub-desc'),
          oncePrice=document.getElementById('bb-once-price'), cta=document.getElementById('bb-cta'),
          supplyEl=document.getElementById('bb-supply');
      var st={pack:'1', plan:'sub'};
      function render(){
        var p=PACKS[st.pack];
        if(!p.sub && st.plan==='sub') st.plan='once';
        packEls.forEach(function(b){b.classList.toggle('selected', b.getAttribute('data-pack')===st.pack);});
        supplyEl.textContent=p.supply;
        subCard.classList.toggle('disabled', !p.sub);
        if(p.sub){ subPrice.innerHTML='<span class="bb-now">'+p.sub.price+'</span><span class="bb-was">'+p.was+'</span><span class="bb-per">'+p.sub.per+'</span>'; subDesc.textContent='20% off · '+p.sub.cad+' · cancel anytime'; }
        else { subPrice.innerHTML='<span class="bb-na">Not for this size</span>'; subDesc.textContent='Choose 1 or 3 bags to subscribe'; }
        oncePrice.innerHTML='<span class="bb-now">'+p.once+'</span><span class="bb-was">'+p.was+'</span>';
        subCard.classList.toggle('selected', st.plan==='sub' && !!p.sub);
        onceCard.classList.toggle('selected', st.plan==='once');
        var url,label;
        if(st.plan==='sub' && p.sub){ url='https://www.trybetterbrand.com/cart/'+p.v+':1?selling_plan='+p.sub.plan; label='Subscribe · '+p.sub.price+p.sub.per+' &rarr;'; }
        else { url='https://www.trybetterbrand.com/cart/'+p.v+':1?discount=AIR20'; label='Add to cart · '+p.once+' &rarr;'; }
        cta.setAttribute('href',withRef(url)); cta.innerHTML=label;
      }
      packEls.forEach(function(b){b.addEventListener('click',function(){st.pack=b.getAttribute('data-pack');render();});});
      subCard.addEventListener('click',function(){if(subCard.classList.contains('disabled'))return;st.plan='sub';render();});
      onceCard.addEventListener('click',function(){st.plan='once';render();});
      cta.addEventListener('click',function(){aqTrack('store_click',{plan:st.plan,pack:st.pack});});
      render();
      var rc=document.getElementById('rep-close'); if(rc) rc.addEventListener('click',closeReport);
    }
  
    function reveal(){report.hidden=false;document.body.style.overflow='hidden';requestAnimationFrame(function(){report.classList.add('on');});}
  
    var AQ_DESC={pm25:'Fine particles from smoke, exhaust and haze, small enough to reach deep into your lungs and bloodstream.',pm10:'Coarser particles like dust, pollen and mold that irritate the nose, throat and airways.',ozone:'Ground-level ozone from traffic and heat that inflames the lungs and can trigger coughing and tightness.',no2:'Nitrogen dioxide from traffic and combustion that irritates the airways and worsens asthma.',so2:'Sulfur dioxide from burning fuel that irritates the airways and eyes.',co:'Carbon monoxide from combustion that lowers how much oxygen your blood can carry.'};
    function aqGuide(cat){cat=(cat||'').toLowerCase();
      if(cat.indexOf('good')>=0)return 'Air quality is good right now. It is a fine day to be active outdoors.';
      if(cat.indexOf('very')>=0)return 'The air is very unhealthy. This is a health alert. Everyone should avoid outdoor exertion and stay indoors with filtered air where possible.';
      if(cat.indexOf('hazard')>=0)return 'The air is hazardous. These are emergency conditions. Stay indoors, keep windows sealed and run air filtration.';
      if(cat.indexOf('sensitive')>=0)return 'The air is unhealthy for sensitive groups. People with lung or heart conditions, older adults and children should cut back on long or intense outdoor activity.';
      if(cat.indexOf('moderate')>=0)return 'Air quality is acceptable. If you are unusually sensitive to air pollution, consider easing up on long or intense time outdoors.';
      if(cat.indexOf('unhealthy')>=0)return 'The air is unhealthy. Everyone may start to feel effects. Sensitive groups should avoid prolonged outdoor exertion and keep windows closed.';
      return 'Here is what today’s readings mean for you.';
    }
    var IC_CLOCK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></svg>';
    var IC_WINDOW='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="1.6"/><path d="M12 4v16M4 12h16"/></svg>';
    var IC_MASK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v4c0 2.6-2.7 4.2-6 4.2S6 15.6 6 13V9z"/><path d="M6 11h12M6 13.5h12"/><path d="M6 9 3 7.6M18 9l3-1.4"/></svg>';
    var IC_LEAF='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21c0-6 3-10.5 8-11.5-1 6.2-4.2 9.4-8 11.5z"/><path d="M12 21c0-6-3-10.5-8-11.5 1 6.2 4.2 9.4 8 11.5z"/><path d="M12 21v-9"/></svg>';
    function tip(ic,t,s){return '<div class="aq-tip"><span class="aq-tip-ic">'+ic+'</span><div class="aq-tip-tx"><b>'+t+'</b><span>'+s+'</span></div></div>';}
    var TIPS=tip(IC_CLOCK,'Time it right','Save long or intense activity for the cleaner hours of the day.')+
      tip(IC_WINDOW,'Seal the indoors','On smoky days keep windows closed and run a HEPA purifier.')+
      tip(IC_MASK,'Wear an N95','A well-fitting N95 helps when fine particles are high outside.')+
      tip(IC_LEAF,'Support your lungs','Help them clear more of what you breathe, every single day.');
    function sellStrip(){return '<section class="aq-sell"><img src="https://air-report.pages.dev/assets/img/gummies-1bag.jpg" alt="BetterLungs Mullein Gummies" loading="lazy"><div class="aq-sell-tx"><div class="t">Support your lungs from the inside</div><div class="s">BetterLungs® mullein gummies, once a day. 20% off today with your report.</div></div><a class="aq-sell-cta" id="bb-cta" href="'+DISC+'" target="_blank" rel="noopener">Get 20% off &rarr;</a></section>';}
    function wireReport(){var rc=document.getElementById('rep-close');if(rc)rc.addEventListener('click',closeReport);var cta=document.getElementById('bb-cta');if(cta){cta.setAttribute('href',withRef(cta.getAttribute('href')));cta.addEventListener('click',function(){aqTrack('store_click',{place:'report_sell'});});}}
    var DISCLAIMER='<section class="rr-disc"><p>The cigarette comparison is an estimate from live PM2.5 (Berkeley Earth: ~22 µg/m³ ≈ one cigarette), not a medical measurement. Air-quality readings are sourced from public monitoring networks for general information only and are not a medical or safety assessment. BetterLungs® is a dietary supplement; these statements have not been evaluated by the FDA and it is not intended to diagnose, treat, cure, or prevent any disease. Individual results vary.</p></section>';
  
    function buildReport(d,email){
      var overall=(typeof d.overallAqi==='number')?d.overallAqi:(d.worst?d.worst.aqi:0);
      var worst=d.worst||{}; var color=worst.color||'#e53935';
      var loc=d.city?esc(d.city)+(d.state?', '+esc(d.state):''):('ZIP '+esc(d.zip));
      var tc=textColor(worst.category);
      var markerPct=Math.max(1,Math.min(99,(overall/500)*100));
      var cig=(typeof d.cigarettes==='number')?d.cigarettes:null;
      var cigTxt='';
      if(cig!==null){var cr=Math.round(cig*10)/10;var cw=(cr===1)?'cigarette':'cigarettes';var whole=Math.min(20,Math.floor(cig));var frac=cig-Math.floor(cig);var rods='<div class="rr-rods" aria-hidden="true">';for(var ri=0;ri<whole;ri++)rods+='<span class="rod"></span>';if(whole<20&&(frac>0.08||whole===0)){var ph=Math.max(8,Math.round(36*(whole===0?Math.max(frac,0.12):frac)));rods+='<span class="rod part" style="height:'+ph+'px"></span>';}if(Math.floor(cig)>20)rods+='<span class="rr-rods-more">+</span>';rods+='</div>';cigTxt='<div class="aq-cig">'+rods+'<div class="aq-cig-tx">Breathing this air for a full day is roughly like smoking <b>'+cr+' '+cw+'</b>.'+((typeof d.pm25_ugm3==='number')?(' Today’s fine-particle level (PM2.5) is <b>'+(Math.round(d.pm25_ugm3*10)/10)+' µg/m³</b>.'):'')+'</div></div>';}
      var cards=(d.metrics||[]).map(function(m){var b=textColor(m.category);return '<div class="aq-card"><div class="top"><span class="lab">'+esc(m.label)+'</span><span class="badge" style="color:'+b+'">'+esc(m.category)+'</span></div><div class="val" data-n="'+m.aqi+'" style="color:'+b+'">0</div><div class="aq-card-meter"><span style="width:'+Math.max(4,Math.min(100,Math.round((m.aqi/300)*100)))+'%;background:'+b+'"></span></div><p class="desc">'+(AQ_DESC[m.key]||'')+'</p></div>';}).join('');
      var pollen=d.pollen?'<div class="aq-pollen"><b>'+esc(d.pollen.name||'Pollen')+'</b> is running <b>'+esc(d.pollen.level||'')+'</b> in your area today.</div>':'';
      report.innerHTML=
        topbar()+
        '<div class="rr-body">'+
          '<div class="aq-loc">The air in '+loc+' &middot; <span>Live U.S. EPA data</span></div>'+
          (d.observed?'<div class="aq-observed">Observed '+esc(d.observed)+'</div>':'')+
          '<section class="aq-hero">'+
            '<div class="aq-big"><span class="n" id="rr-big" style="color:'+tc+'">0</span><span class="unit">AQI</span></div>'+
            '<div class="aq-cat" style="color:'+tc+'"><span class="dot" style="background:'+color+'"></span>'+esc(worst.category||'')+'</div>'+
            '<div class="aq-scale"><span class="aq-marker" style="left:'+markerPct+'%"></span></div>'+
            '<div class="aq-scale-lbls"><span>0</span><span>50</span><span>100</span><span>150</span><span>200</span><span>300</span><span>500</span></div>'+
            '<div class="aq-primary">Primary pollutant right now: <b>'+esc(worst.label||'')+'</b></div>'+
          '</section>'+
          cigTxt+
          '<section class="aq-block"><h2 class="aq-h">The pollutants in your air</h2><div class="aq-grid">'+cards+'</div></section>'+
          '<section class="aq-block"><h2 class="aq-h">What this means for you today</h2><div class="aq-means" style="border-left-color:'+tc+'"><span class="aq-means-ic" style="color:'+tc+'"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 11.5v4.5"/><circle cx="12" cy="8.2" r=".7" fill="currentColor" stroke="none"/></svg></span><p class="aq-guide">'+aqGuide(worst.category)+'</p></div><p class="aq-note">The Air Quality Index runs from 0 to 500. Under 50 is good, over 100 begins to affect sensitive groups, and over 150 can affect everyone.</p></section>'+
          '<section class="aq-block"><h2 class="aq-h">How to protect yourself today</h2><div class="aq-tips-grid">'+TIPS+'</div></section>'+
          pollen+
          sellStrip()+
          (email?'<div class="rr-mailed">Full report also sent to <b>'+esc(email)+'</b></div>':'')+
        '</div>'+
        DISCLAIMER;
      reveal();
      countUp(document.getElementById('rr-big'),overall,1200);
      report.querySelectorAll('.aq-card .val').forEach(function(el){countUp(el,parseInt(el.dataset.n,10),1000);});
      wireReport();
    }
    function buildFallback(zip,email){
      report.innerHTML=
        topbar()+
        '<div class="rr-body">'+
          '<div class="aq-loc">Your air report &middot; ZIP '+esc(zip)+'</div>'+
          '<section class="aq-hero"><h1 class="aq-h" style="font-size:26px;margin-bottom:10px">Your report is on its way</h1><p class="aq-guide">We couldn’t reach a live monitor near you this minute, but your full personalized report is on its way'+(email?' to <b>'+esc(email)+'</b>':'')+'. Here is how to protect your lungs in the meantime.</p></section>'+
          '<section class="aq-block"><h2 class="aq-h">How to protect yourself today</h2><div class="aq-tips-grid">'+TIPS+'</div></section>'+
          sellStrip()+
        '</div>'+
        DISCLAIMER;
      reveal(); wireReport();
    }
  
    form.addEventListener('submit', async function(e){
      e.preventDefault();
      if(errEl) errEl.hidden=true;
      var fd=new FormData(form);
      var d={first_name:(fd.get('first_name')||'').toString().trim(),zip:(fd.get('zip')||'').toString().replace(/\D/g,'').slice(0,5),email:(fd.get('email')||'').toString().trim(),phone:(fd.get('phone')||'').toString().trim()};
      if(d.zip.length!==5){showErr('Please enter a valid 5-digit ZIP code.');return;}
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d.email)){showErr('Please enter a valid email address.');return;}
      btn.disabled=true; var orig=btn.innerHTML; btn.textContent='Pulling your live readings…';
      captureLead(d);
      fetch(LOGBASE+'/aq-log',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({page_version:VERSION,variant:VARIANT,day:dayKey(),ts:new Date().toISOString(),session_id:SID,vid:VID,email:d.email,phone:d.phone,zip:d.zip,first_name:d.first_name}),keepalive:true}).catch(()=>{});
      try{if(window.fbq)fbq('trackSingle',PIXEL_ID,'Lead',{content_name:'air-report',page_version:VERSION,variant:VARIANT});}catch(_){}
      try{if(window.Northbeam&&Northbeam.fireEmailCaptureEvent)Northbeam.fireEmailCaptureEvent(d.email);}catch(_){}
      try{
        var res=await fetch(WORKER+'/aqi?zip='+d.zip);
        var data=await res.json();
        if(data&&data.ok&&data.metrics&&data.metrics.length){ buildReport(data,d.email); }
        else { buildFallback(d.zip,d.email); }
      }catch(_e){ btn.disabled=false; btn.innerHTML=orig; showErr('Couldn’t pull your readings just now. Try again in a moment.'); return; }
      btn.disabled=false; btn.innerHTML=orig;
    });
  
    // Direct preview: open /?zip=78201 (or /?preview) to jump straight to the report, no form, no lead capture
    (function(){
      var m=(location.search||'').match(/[?&]zip=(\d{5})/);
      var zip = m ? m[1] : (/[?&]preview/.test(location.search) ? '10001' : null);
      if(!zip) return;
      fetch(WORKER+'/aqi?zip='+zip).then(function(r){return r.json();}).then(function(data){
        if(data&&data.ok&&data.metrics&&data.metrics.length) buildReport(data,''); else buildFallback(zip,'');
      }).catch(function(){ buildFallback(zip,''); });
    })();
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Update cart counter in real-time by observing the drawer element
  (function() {
    // Function to update the header counter based on the drawer counter value
    function updateCartCountBubble(itemCount) {
      const cartBubbles = document.querySelectorAll('.cart-count-bubble');
      
      cartBubbles.forEach((bubble) => {
        const parentLink = bubble.closest('a');
        if (!parentLink) return;

        // Update or create the counter
        if (itemCount > 0) {
          // Ensure the bubble is visible
          bubble.style.display = '';

          // Update the visible number
          let visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
          if (itemCount < 100) {
            if (!visibleSpan) {
              visibleSpan = document.createElement('span');
              visibleSpan.setAttribute('aria-hidden', 'true');
              bubble.insertBefore(visibleSpan, bubble.firstChild);
            }
            visibleSpan.textContent = itemCount;
          } else {
            // If >= 100, remove the visible span
            if (visibleSpan) {
              visibleSpan.remove();
            }
          }

          // Update the accessible text
          let hiddenSpan = bubble.querySelector('span.visually-hidden');
          if (!hiddenSpan) {
            hiddenSpan = document.createElement('span');
            hiddenSpan.className = 'visually-hidden';
            bubble.appendChild(hiddenSpan);
          }
          const countText = itemCount === 1 ? 'item' : 'items';
          hiddenSpan.textContent = `${itemCount} ${countText}`;
        } else {
          // Hide the counter if the cart is empty
          bubble.style.display = 'none';
        }
      });

      // If no bubble exists, create one when necessary
      if (itemCount > 0 && cartBubbles.length === 0) {
        const cartLinks = document.querySelectorAll('a[href*="cart"], .ntg-cart-link');
        cartLinks.forEach((link) => {
          if (!link.querySelector('.cart-count-bubble')) {
            const newBubble = document.createElement('div');
            newBubble.className = 'cart-count-bubble';
            
            if (itemCount < 100) {
              const visibleSpan = document.createElement('span');
              visibleSpan.setAttribute('aria-hidden', 'true');
              visibleSpan.textContent = itemCount;
              newBubble.appendChild(visibleSpan);
            }
            
            const hiddenSpan = document.createElement('span');
            hiddenSpan.className = 'visually-hidden';
            hiddenSpan.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
            newBubble.appendChild(hiddenSpan);
            
            link.appendChild(newBubble);
          }
        });
      }
    }

    // Function to get the counter value from the drawer
    function getCartCountFromDrawer() {
      const cartCountElement = document.querySelector('.amp-cart__header-cart-count');
      if (!cartCountElement) return null;
      
      const text = cartCountElement.textContent?.trim() || '';
      const count = parseInt(text, 10);
      return isNaN(count) ? null : count;
    }

    // Observe changes in the amp-cart__header-cart-count element
    function observeCartCount() {
      const cartCountElement = document.querySelector('.amp-cart__header-cart-count');
      
      if (!cartCountElement) {
        // Try again after a delay if the element doesn't exist yet
        setTimeout(observeCartCount, 500);
        return null;
      }

      // Update immediately with the current value
      const currentCount = getCartCountFromDrawer();
      if (currentCount !== null) {
        updateCartCountBubble(currentCount);
      }

      // Create observer to detect changes
      const observer = new MutationObserver(() => {
        const newCount = getCartCountFromDrawer();
        if (newCount !== null) {
          updateCartCountBubble(newCount);
        }
      });

      // Observe changes in text and attributes
      observer.observe(cartCountElement, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: false
      });

      return observer;
    }

    // Initialize when DOM is ready
    function initCartCounterObserver() {
      observeCartCount();
      
      // Try again after a delay to ensure the element has loaded
      setTimeout(() => {
        observeCartCount();
      }, 1000);
      
      // Try once more after 2 seconds (in case the APP loads later)
      setTimeout(() => {
        observeCartCount();
      }, 2000);
    }

    // Execute when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartCounterObserver);
    } else {
      initCartCounterObserver();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
